import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { stubFN, pluckNumber, convertColor } from '../../../lib';
import Tool from '../tool';
import ScrollTrack from './scroll-track';
import ScrollAnchor from './scroll-anchor';
import ScrollButtons from './scroll-buttons';
import { mergeConf } from '../helper';
var UNDEF;

var Scroller =
/*#__PURE__*/
function (_Tool) {
  _inherits(Scroller, _Tool);

  function Scroller() {
    _classCallCheck(this, Scroller);

    return _possibleConstructorReturn(this, _getPrototypeOf(Scroller).apply(this, arguments));
  }

  _createClass(Scroller, [{
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(Scroller.prototype), "configureAttributes", this).call(this, a);

      var b = this.config,
          c = this.getFromEnv('chart-attrib');
      b.conf = {}, b.color = c.scrollcolor && convertColor(c.scrollcolor), b.padding = pluckNumber(c.scrollpadding, 0), b.height = pluckNumber(c.scrollheight, 12), b.width = pluckNumber(c.scrollwidth, 12), b.displayFlat = pluckNumber(c.flatscrollbars, 0), b.scrollBar3DLighting = pluckNumber(c.scrollbar3dlighting, 1), b.startPercent = Math.min(1, Math.max(0, parseFloat(c.scrolltoend) || 0)), b.showButtons = !!pluckNumber(c.scrollshowbuttons, 1), b.buttonPadding = pluckNumber(c.scrollbtnpadding, 0), b.anchorFill = a.anchorFill, b.anchorStroke = a.anchorStroke, b.trackFill = a.trackFill, b.trackStroke = a.trackStroke, b.buttonFill = a.buttonFill, b.buttonStroke = a.buttonStroke, b.buttonPointerFill = a.buttonPointerFill, b.drawStripes = a.drawStripes, b.stripesStroke = a.stripesStroke, b.restrictScrollAnchor = pluckNumber(a.restrictScrollAnchor, 1), this.setConfiguaration(a), b.evt = {
        tooltext: UNDEF,
        click: stubFN,
        hover: [stubFN, stubFN]
      }, this.createScrollItems();
    }
  }, {
    key: "createScrollItems",
    value: function createScrollItems() {
      var a = this,
          b = this.config,
          c = a.getChildren('scrollTrack') && a.getChildren('scrollTrack')[0],
          d = a.getChildren('scrollAnchor') && a.getChildren('scrollAnchor')[0],
          e = a.getChildren('scrollButtons') && a.getChildren('scrollButtons')[0],
          f = a.getChildren('scrollButtons') && a.getChildren('scrollButtons')[0];
      c || (c = a.attachChild(ScrollTrack, 'scrollTrack'), c.configure({
        trackFill: b.trackFill,
        trackStroke: b.trackStroke
      }), c.attachEventHandlers()), d || (d = a.attachChild(ScrollAnchor, 'scrollAnchor'), d.configure({
        anchorFill: b.anchorFill,
        anchorStroke: b.anchorStroke,
        drawStripes: b.drawStripes,
        stripesStroke: b.stripesStroke
      }), d.attachEventHandlers()), !e && b.showButtons && (e = a.attachChild(ScrollButtons, 'scrollStartButton'), e.configure({
        type: 'start',
        buttonFill: b.buttonFill,
        buttonStroke: b.buttonStroke,
        buttonPointerFill: b.buttonPointerFill
      }), e.attachEventHandlers()), !f && b.showButtons && (f = a.attachChild(ScrollButtons, 'scrollEndButton'), f.configure({
        type: 'end',
        buttonFill: b.buttonFill,
        buttonStroke: b.buttonStroke,
        buttonPointerFill: b.buttonPointerFill
      }), f.attachEventHandlers());
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'scroller';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'scroller';
    }
  }, {
    key: "setConfiguaration",
    value: function setConfiguaration(a) {
      var b = this.config,
          c = this.getFromEnv('chart'),
          d = c.getFromEnv('color-manager');
      b.color || (b.color = '#' + d.getColor('altHGridColor')), mergeConf(a, b);
    }
  }, {
    key: "getLogicalSpace",
    value: function getLogicalSpace() {
      var a = this.config,
          b = a.conf,
          c = {};
      return mergeConf(a, c), mergeConf(c, b), _get(_getPrototypeOf(Scroller.prototype), "getLogicalSpace", this).call(this);
    }
  }, {
    key: "setDimension",
    value: function setDimension(a) {
      _get(_getPrototypeOf(Scroller.prototype), "setDimension", this).call(this, a);

      var b = this,
          c = b.getLinkedParent(),
          d = c.getPosition && c.getPosition() || {},
          e = b.getChildren('scrollTrack')[0].config;
      e.transLateX = d.x || 0, e.transLateY = d.y || 0;
    }
  }, {
    key: "draw",
    value: function draw() {
      var a = this,
          b = a.config,
          c = b.conf,
          d = {};
      c.isHorizontal ? delete d.width : delete d.height, mergeConf(d, b, !0), a.addGraphicalElement({
        el: 'group',
        attr: {
          name: 'scrollContainer'
        },
        component: a,
        container: {
          id: 'scrollerContainer',
          label: 'scroller',
          isParent: !0
        },
        label: 'scrollerGroup',
        id: 'scrollerGroup'
      });
    }
  }, {
    key: "attachEventHandlers",
    value: function attachEventHandlers(a) {
      var b = this,
          c = this.config,
          d = c.evt;
      return a && (a.scroll && 'function' == typeof a.scroll && (d.scroll = a.scroll), a.scrollStart && 'function' == typeof a.scrollStart && (d.scrollStart = a.scrollStart), a.scrollEnd && 'function' == typeof a.scrollEnd && (d.scrollEnd = a.scrollEnd)), b;
    }
  }]);

  return Scroller;
}(Tool);

Scroller.registerSymbol = UNDEF, Scroller._setConfiguaration = stubFN;
export default Scroller;